import type { CustomTrackingParams, UserActivityData } from "app/pages/sales-intelligence/types/customTrackingParams";

const trackingParamAliases: Record<keyof UserActivityData, keyof CustomTrackingParams> = {
    savedSearchesCount: "SavedSearchCount",
    staticListsCount: "StaticListCount",
    hasCrmIntegration: "CRMIntegration",
    hasCustomCrmList: "CRMList",
    useLeadEnrichment: "UsedCsvEnrich",
    revealedContactsCount: "ContactRevealCount",
    contactPersonasCount: "CustomUserPersona",
    hasCustomSignals: "AddedCustomSignal",
    signalsCount: "SignalsCount",
};

export default trackingParamAliases;
